import type { IGetCommentResponse } from '../../../api/types'
import { findCommentInTree } from './findCommentInTree'

function resolveL2AnchorId(roots: IGetCommentResponse[], nodeId: number): number | null {
  if (!nodeId) return null

  const node = findCommentInTree(roots, nodeId)
  if (!node) return null

  const rootIds = new Set(roots.map((r) => r.id))

  if (node.parent_id != null && rootIds.has(node.parent_id)) {
    return node.id
  }

  let current = node
  while (current.parent_id != null && !rootIds.has(current.parent_id)) {
    const parent = findCommentInTree(roots, current.parent_id)
    if (!parent) return null
    current = parent
  }

  if (current.parent_id != null && rootIds.has(current.parent_id)) {
    return current.id
  }

  return null
}

export function resolveThreadAnchorId(roots: IGetCommentResponse[], nodeId: number): number | null {
  if (!nodeId) return null

  const l2Anchor = resolveL2AnchorId(roots, nodeId)
  if (l2Anchor != null) return l2Anchor

  if (roots.some((r) => r.id === nodeId)) return nodeId

  return null
}
